<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
          style="padding-top: 0; margin-top: 0">
          <el-form-item label="生产部门：">
            <el-select size="medium" filterable v-model="searchForm.department" placeholder="请选择" :clearable="true">
              <el-option v-for="item in departmentList" :key="item.ID" :value="item.ID" :label="item.DEPARTMENT_NAME">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="入库日期：">
            <el-date-picker v-model="searchForm.WAREHOUSING_DAY" type="date" value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
              format="yyyy-MM-dd" @input="clear">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="queryData()">筛选</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="updateFormVisible = true">调整入库产品单价</el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" plain @click="batchExport">批量导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="tableData" border stripe>
          <!-- @selection-change="handleSelectionChange" -->
          <!-- <el-table-column type="selection" width="50"></el-table-column> -->
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="RECORD_ID" label="入库单ID"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="生产部门"></el-table-column>
          <el-table-column prop="DELIVER_DAY" label="入库时间"></el-table-column>
          <el-table-column prop="CREATE_TIME" label="创建时间"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="openDetail(scope.row)">查看</el-button>
              <el-button type="text" @click="Export(scope.row)">导出详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 调整入库产品单价 -->
    <el-dialog title="调整入库产品单价" center :visible.sync="updateFormVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="updateForm" v-model="updateForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleUpdateSuccess"
          :on-remove="handleUpdateRemove" name="tmp" accept=".xls, .xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downloadUpdateTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="updateFormVisible = false">取 消</el-button>
        <el-button size="small" @click="updateStockedProductsPrice">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { queryDepartment } from 'api/productDepart';
import http from '../../assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {
        DAY_INTERVAL: [],
      },
      departmentList: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      firstFormadd: {},
      file_name: '',
      fileList: [],
      updateFormVisible: false,
      updateForm: {},
      checkedArray: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.PRO_RECEIPT) != '{}' && this.PRO_RECEIPT != undefined) {
      this.searchForm = this.PRO_RECEIPT.CONDITION;
      this.currentPage = this.PRO_RECEIPT.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryDepartment();
  },
  computed: {
    PRO_RECEIPT() {
      return this.$store.state.SAVE_PRO_RECEIPT;
    },
  },
  methods: {
    queryDepartment() {
      queryDepartment().then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryData() {
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 2,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.department) {
        params.PRODUCE_DEPARTMENT_ID = this.searchForm.department;
      }
      // if (this.searchForm.WAREHOUSING_DAY) {
      //   params.DELIVER_DAY = this.searchForm.WAREHOUSING_DAY;
      // }
      if (this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].LIST;
          this.totalCount = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_PRO_RECEIPT', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail(row) {
      this.$router.push({ path: `/proReceiptDetails/${row.PRODUCE_DEPARTMENT_ID}`, params: { department: row.PRODUCE_DEPARTMENT_ID } });
      sessionStorage.setItem('recordID', row.RECORD_ID);
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    }, // 调整入库产品单价的下载模板
    downloadUpdateTemp() {
      window.location.href = 'https://service.linkda.com.cn/file/templates/updateStockedProductsPriceTemplate.xlsx';
    },
    handleUpdateSuccess(response, file, fileList) {
      this.file_name = response.file_name;
    },
    handleUpdateRemove(file, fileList) {
      this.fileList = [];
    },
    // 调整入库产品单价
    async updateStockedProductsPrice() {
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 4,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        FILE_NAME: this.file_name,
      };
      await http.post(params)
        .then((result) => {
          if (!result[0]) {
            this.$message.show({ text: '导入成功', type: 'success' });
          }
          this.updateFormVisible = false;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      this.fileList = [];
      this.file_name = '';
    },
    // 导出详情
    Export(row) {
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 5,
        RECORD_ID: row.RECORD_ID,
      };
      http.post(params)
        .then((result) => {
          if (result[0]) {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          } else {
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    batchExport() {
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 6,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.department) {
        params.PRODUCE_DEPARTMENT_ID = this.searchForm.department;
      }
      if (this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      http.post(params).then((res) => {
        if (res[0].NON_DATA.length != 0) {
          this.$message.show({ text: `订单ID为${res[0].NON_DATA.toString()}的订单无数据，无法导出`, type: 'warning' });
        }
        window.location.href = res[0].FILE_PATH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    clear(e) {
      this.$nextTick(() => {
        if (e == null) {
          this.$set(this.searchForm, 'DAY_INTERVAL', []);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/proReceipt.vue